import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

function Banner() {
  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (!isModalOpen) return undefined;

    const closeOnEscape = (event) => {
      if (event.key === 'Escape') setIsModalOpen(false);
    };

    document.addEventListener('keydown', closeOnEscape);
    return () => document.removeEventListener('keydown', closeOnEscape);
  }, [isModalOpen]);

  return (
    <section className="home-hero">
      <div className="home-hero__glow home-hero__glow--one" aria-hidden="true" />
      <div className="home-hero__glow home-hero__glow--two" aria-hidden="true" />

      <div className="app-container home-hero__grid">
        <div className="home-hero__content">

          <h1>Ассоциация Практикующих Психологов</h1>

          <p className="home-hero__lead">
            Объединяем психологов, помогаем развиваться в профессии и создаём сообщество, где можно получать поддержку, делиться опытом и расти вместе.
          </p>

          <div className="home-hero__actions">
            <Link className="app-button app-button--primary" to="/find-psychologist">
              Найти психолога
            </Link>
            <Link className="app-button app-button--secondary" to="/join_association">
              Вступить в АПП
            </Link>
          </div>

          
        </div>

          

         <div className="home-hero__visual">
  <div className="home-hero__photo-wrap">
    <img
      className="home-hero__photo"
      src={`${process.env.PUBLIC_URL}/images/banner200.png`}
      alt="Участники Ассоциации практикующих психологов"
    />

    <button
      className="home-hero__video-overlay"
      type="button"
      onClick={() => setIsModalOpen(true)}
    >
      <span className="home-hero__video-overlay-icon">▶</span>
      <span>Смотреть видео</span>
    </button>
  </div>
</div>

        
        
      </div>

      {isModalOpen && (
        <div className="app-modal" role="presentation" onMouseDown={() => setIsModalOpen(false)}>
          <div
            className="app-modal__dialog"
            role="dialog"
            aria-modal="true"
            aria-labelledby="about-app-video-title"
            onMouseDown={(event) => event.stopPropagation()}
          >
            <div className="app-modal__header">
              <div>
                <span className="app-eyebrow app-eyebrow--light">Об Ассоциации</span>
                <h2 id="about-app-video-title">Знакомство с АПП</h2>
              </div>
              <button className="app-modal__close" type="button" onClick={() => setIsModalOpen(false)} aria-label="Закрыть">
                ×
              </button>
            </div>
            <video className="app-modal__video" controls autoPlay>
              <source
                src={`${process.env.PUBLIC_URL}/videos/Whiteboard Animation Toolkit_free.mp4`}
                type="video/mp4"
              />
              Ваш браузер не поддерживает видео.
            </video>
          </div>
        </div>
      )}
    </section>
  );
}

export default Banner;
